import { render, staticRenderFns } from "./checklists.vue?vue&type=template&id=18d2b0fc&scoped=true"
import script from "./checklists.vue?vue&type=script&lang=js"
export * from "./checklists.vue?vue&type=script&lang=js"
import style0 from "./checklists.vue?vue&type=style&index=0&id=18d2b0fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d2b0fc",
  null
  
)

export default component.exports